module.exports = __webpack_public_path__ + "27d4829af79d77dbb817664ca68e5a1b.ico";